import { createSlice } from "@reduxjs/toolkit";
import { IIntegrationPartner } from "../../interfaces/interfaces";

interface IState {
  integrationPartners: Record<string, IIntegrationPartner>;
  isSideBarCollapse: Boolean;
  dataLimitationConfig: { [x: string]: any };
  dataRestrictionConfig: { [x: string]: any };
  workspaceRestrictionsConfig: string[];
  siPromoConfig: { [key: string]: boolean };
}

const INITIAL_STATE: IState = {
  integrationPartners: {},
  isSideBarCollapse: true,
  dataLimitationConfig: {},
  dataRestrictionConfig: {},
  workspaceRestrictionsConfig: [],
  siPromoConfig: {},
};

const config = createSlice({
  name: "config",
  initialState: INITIAL_STATE,
  reducers: {
    setIntegrationPartners: (state, action) => {
      state.integrationPartners = action.payload;
    },
    setSideBarCollapse: (state, action) => {
      state.isSideBarCollapse = action.payload;
    },
    setDataLimitationConfig: (state, action) => {
      state.dataLimitationConfig = action.payload;
    },
    setDataRestrictionConfig: (state, action) => {
      state.dataRestrictionConfig = action.payload;
    },
    setWorkspaceRestrictionsConfig: (state, action) => {
      state.workspaceRestrictionsConfig = action.payload;
    },
    setSIPromoConfig: (state, action) => {
      state.siPromoConfig = action.payload;
    },
  },
});

export const {
  setIntegrationPartners,
  setSideBarCollapse,
  setDataLimitationConfig,
  setDataRestrictionConfig,
  setWorkspaceRestrictionsConfig,
  setSIPromoConfig,
} = config.actions;

export const configReducer = config.reducer;
